module.exports = __webpack_public_path__ + "img/aomen8.33c920d1.jpg";